import {Injectable} from '@angular/core';
import {
  CardNoteObject,
  CardObject,
  ConnectorMessage,
  LinkNoteObject,
  LinkObject,
  MoveEventData
} from './connector-message';
import {ConnectorMessageType} from './connector-message.type';
import {DeckType} from './card-deck';
import {CardNoteType, NoteType} from './custom-objects';
import {CommunityMember} from './CommunityMember';

@Injectable({
  providedIn: 'root'
})

export class MessageFactoryService {

  private designName: string;
  private createdDateTime: string;
  private communityMember: CommunityMember;

  constructor() {
  }

  public initialize(designName: string, createdDateTime: string) {
    if (designName !== undefined && createdDateTime !== undefined && designName !== null && createdDateTime !== null) {
      this.designName = designName;
      this.createdDateTime = createdDateTime;
    }else {
      throw new Error('Init of message-factory-service error: designName = ' + designName + ', createdDateTime = ' + createdDateTime);
    }
  }

  public isInitialized() {
    return this.designName !== undefined && this.designName !== null && this.createdDateTime !== undefined && this.createdDateTime !== null;
  }

  public checkInitialized() {
    if (!this.isInitialized()) {
      throw new Error('MessageFactoryService not initialized.');
    }
  }

  createEmptyMessage(): ConnectorMessage {
    return {connectorMessageType: ConnectorMessageType.EMPTY_MESSAGE, designName: null, createdDateTime: null};
  }

  public createMessageAddCard(
    cardObject: CardObject,
    moveEventData: MoveEventData): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ADD_CARD,
      cardObject,
      createdDateTime: this.createdDateTime,
      designName: this.designName,
      moveEventData};
  }

  public createMessageMoveCard(
    cardObject: CardObject,
    moveEventData: MoveEventData): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.MOVE_CARD,
      cardObject,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      moveEventData};
  }

  createMessageDeleteCard(
    cardObject: CardObject,
  ): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.DELETE_CARD,
      cardObject,
      designName: this.designName,
      createdDateTime: this.createdDateTime};
  }

  createMessageDeleteLink(
    linkObject: LinkObject,
  ): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.DELETE_LINK,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject};
  }

  createMessageAddLink(
    linkObject: LinkObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ADD_LINK,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject};
  }

  createMessageResetDesign(): ConnectorMessage {
    this.checkInitialized();
    return {connectorMessageType: ConnectorMessageType.RESET_DESIGN,
      designName: this.designName, createdDateTime: this.createdDateTime};
  }

  createMessageAddCardNote(
    cardObject: CardObject,
    cardNoteObject: CardNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ADD_CARD_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject,
      cardNoteObject};
  }

  createMessageChangeCardNote(
    cardObject: CardObject,
    cardNoteObject: CardNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.CHANGE_CARD_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject, cardNoteObject};
  }

  createMessageDeleteCardNote(
    cardObject: CardObject,
    cardNoteObject: CardNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.DELETE_CARD_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject,
      cardNoteObject};
  }

  createMessageAddLinkNote(
    linkObject: LinkObject,
    linkNoteObject: LinkNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ADD_LINK_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject,
      linkNoteObject};
  }

  createMessageUpdateLinkNote(
    linkObject: LinkObject,
    linkNoteObject: LinkNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.CHANGE_LINK_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject, linkNoteObject};
  }

  createMessageDeleteLinkNote(
    linkObject: LinkObject,
    linkNoteObject: LinkNoteObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.DELETE_LINK_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject,
      linkNoteObject};
  }

  createMessageEnterDesign( communityMember?: CommunityMember): ConnectorMessage {
    this.checkInitialized();
    if (communityMember) {
      this.communityMember = communityMember;
      return {connectorMessageType: ConnectorMessageType.ENTER_DESIGN,
        designName: this.designName, createdDateTime: this.createdDateTime, communityMember};
    }else{
      return {connectorMessageType: ConnectorMessageType.ENTER_DESIGN,
        designName: this.designName, createdDateTime: this.createdDateTime};
    }
  }

  createMessageLeaveDesign(): ConnectorMessage {
    this.checkInitialized();
    return {connectorMessageType: ConnectorMessageType.LEAVE_DESIGN,
      designName: this.designName, createdDateTime: this.createdDateTime};
  }

  createMessageEnterCardLink(cardObject: CardObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ENTER_CARD_LINK,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject,
      communityMember: this.communityMember};
  }
  createMessageLeaveCardLink(cardObject: CardObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.LEAVE_CARD_LINK,
      designName: this.createdDateTime,
      createdDateTime: this.createdDateTime,
      cardObject};
  }

  createMessageEnterCardNote(cardObject: CardObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ENTER_CARD_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject,
      communityMember: this.communityMember};
  }

  createMessageLeaveCardNote(cardObject: CardObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.LEAVE_CARD_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      cardObject};
  }

  createMessageEnterLinkNote(linkObject: LinkObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.ENTER_LINK_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject,
      communityMember: this.communityMember};
  }

  createMessageHeartBeatLock(message: ConnectorMessage): ConnectorMessage {
    const heartBeatMessage = this.createEmptyMessage();
    heartBeatMessage.connectorMessageType = ConnectorMessageType.HEARTBEAT_LOCK;
    heartBeatMessage.designName = message.designName;
    heartBeatMessage.userId = message.userId;
    heartBeatMessage.createdDateTime = message.createdDateTime;
    heartBeatMessage.communityMember = message.communityMember;
    heartBeatMessage.cardWeb = message.cardWeb;
    return heartBeatMessage;
  }

  createMessageLeaveLinkNote(linkObject: LinkObject): ConnectorMessage {
    this.checkInitialized();
    return {
      connectorMessageType: ConnectorMessageType.LEAVE_LINK_NOTE,
      designName: this.designName,
      createdDateTime: this.createdDateTime,
      linkObject};
  }

  public buildLinkObject(
    sourceId: number,
    targetId: number,
    sourceDeckType: DeckType,
    targetDeckType: DeckType,
    sourceName: string,
    targetName: string,
    relationId?: number
  ): LinkObject {
    return {sourceId, targetId, sourceDeckType, targetDeckType, sourceName, targetName, relationId};
  }

  public buildCardObject(
    cardDeckId: number,
    id: number,
    deckType: DeckType,
    name: string): CardObject {
    return {cardDeckId, id, deckType, name};
  }

  public buildMoveEventData(
    posX: number,
    posY: number): MoveEventData {
    return {posX, posY};
  }

  buildCardNoteObject(
    noteType: CardNoteType,
    noteText: string): CardNoteObject {
    return { noteType, noteText };
  }

  buildLinkNoteObject(
    noteType: NoteType,
    noteText: string): LinkNoteObject {
      return { noteType, noteText };
  }
}
